import { IGetAllChecklistEntregaUseCase } from "../../../presentation/useCases/read/get_all_checklist_entrega_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ChecklistEntrega } from "../../models/checklist_entrega";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllChecklistEntregaUseCase
 */

export class GetAllChecklistEntregaUseCase
  extends BasePaginatedUseCase<ChecklistEntrega>
  implements IGetAllChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(
    codigo?: string,
    descricao?: string,
    status?: number,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllChecklistEntregas(
      codigo,
      descricao,
      status,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
